import { Link } from "react-router-dom";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { BsArrowRight } from "react-icons/bs";
import { useRef, useEffect, Fragment } from "react";
import { IoMdArrowRoundForward } from "react-icons/io";
import { ReactComponent as Aicon } from "../../Asset/home-arrow-right.svg";
import { ReactComponent as Nice } from "../../Asset/niceLogo.svg";
import { AiOutlinePlus } from "react-icons/ai";
import { FiMinus } from "react-icons/fi";
import { useState } from "react";
import { ReactComponent as NiceLog } from "../../Asset/nice_1.svg";
import { ReactComponent as WhiteArror } from "../../Asset/greaterwhite.svg";
import { ReactComponent as RedArrrow } from "../../Asset/greaterred.svg";
import { ReactComponent as Greter } from "../../Asset/greaterT.svg";
import { ReactComponent as Less } from "../../Asset/lessT.svg";
import { ReactComponent as ShipLog } from "../../Asset/Group home.svg";
import { ReactComponent as PLay } from "../../Asset/play1.svg";
import Aos from "aos";
import "aos/dist/aos.css";
import "./Home.css";

const items = [
  {
    id: 1,
    title: "Transport crew to and from offshore with ease.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471102/psv_eny33s.png",
  },
  {
    id: 2,
    title: "Transport crew to and from offshore with ease.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471102/ahts_pfl7kj.png",
  },
  {
    id: 3,
    title: "Transport crew to and from offshore with ease.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/fsiv_kj79ls.png",
  },
  {
    id: 4,
    title: "Transport crew to and from offshore with ease.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
  },
];

const contents = [
  {
    id: 1,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
  {
    id: 2,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    img: "https://res.cloudinary.com/dquhjbqzf/image/upload/v1725646641/Rectangle_206004_pyb09n.png",
  },
  {
    id: 3,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
  {
    id: 4,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
  {
    id: 5,
    date: "Nov 14",
    min: "3 min read",
    title: "U.S. Coast Guard Takes Over Cleanup of $3M Yacht",
    content:
      "Lorem ipsum dolor sit amet consectetur. Semper ut aliquam aliquet magna felis ac fermentum. Sem risus consectetur morbi arcu consequat leo tellus tincidunt porta. Auctor pretium donec ultrices tristique ",
  },
];

const faqs = [
  {
    question:
      "What are the main challenges facing the Nigerian maritime industry?",
    answer:
      "Vatug Solution: Vatug simplifies logistics by consolidating the entire vessel chartering process—from inquiry to delivery—on one platform. This streamlined approach reduces operational bottlenecks, improves transparency, and lowers overall costs for stakeholders, directly addressing infrastructure and efficiency challenges.",
  },
  {
    question:
      "How does the government regulate maritime activities in Nigeria?",
    answer:
      "Vatug Solution: Vatug’s platform integrates regulatory compliance checks (such as KYC and vessel registration) into its workflow, ensuring that all charters and transactions adhere to Nigerian maritime laws. This built-in compliance reduces administrative burden and helps companies meet regulatory requirements.",
  },
  {
    question: "What is being done to improve port infrastructure?",
    answer:
      "Vatug Solution: Vatug supports port operators by providing a digital interface for managing charter bookings and logistics, reducing congestion and manual paperwork. The platform’s data-driven insights can also inform stakeholders about peak usage times, helping optimize port operations and infrastructure usage.",
  },
];

const Home = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(
    sessionStorage.getItem("bgImageLoaded") === "true"
  );

  const handleToggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // useEffect(() => {
  //   if (!imageLoaded) {
  //     const img = new Image();
  //     img.src =
  //       "https://res.cloudinary.com/du44pwjoi/image/upload/v1737629070/aerial-view-oil-and-gas-tanker-ship-oil-depot-term-2025-01-10-04-44-06-utc_1_j6wouk.png";
  //     img.onload = () => {
  //       setImageLoaded(true);
  //       sessionStorage.setItem("bgImageLoaded", "true");
  //     };
  //   }
  // }, [imageLoaded]);

  useEffect(() => {
    if (!imageLoaded) {
      const imageUrls = [
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737629070/aerial-view-oil-and-gas-tanker-ship-oil-depot-term-2025-01-10-04-44-06-utc_1_j6wouk.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737122562/portrait-of-team-male-leader-in-warehouse-with-sta-2024-10-20-10-28-55-utc_3_hqwakj.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736674386/Frame_1707480236_gmeizr.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737630324/a-massive-cargo-ship-wood-chips-carrier-in-the-sea-2023-12-15-02-23-17-utc_fimshu.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737374116/Heavy_Lift_Pipe-lay_Multi_Purpose_Vessel.I15.2k_2_wolkb9.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737669233/business-industry-innovation-technology-people-wi-2023-11-27-05-00-47-utc_1_1_rz1wp0.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737669343/cards_rdddjq.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737669451/cards_1_jfyez2.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737629321/charlesdeluvio-Lks7vei-eAg-unsplash_fzziao.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1737374116/Heavy_Lift_Pipe-lay_Multi_Purpose_Vessel.I15.2k_2_wolkb9.png",
        "https://res.cloudinary.com/dot2onqdb/image/upload/v1731315174/portrait-native-american-engineer-technician-wearing-safty-uniform-hand-contril-automation-robot-arm-welding-machine-with-laptop-industrial-40-factory-background-concept_1_rqcpki.png",
        "https://res.cloudinary.com/dot2onqdb/image/upload/v1731315174/portrait-native-american-engineer-technician-wearing-safty-uniform-hand-contril-automation-robot-arm-welding-machine-with-laptop-industrial-40-factory-background-concept_1_rqcpki.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775080/a-person-holding-up-a-transparent-globe-with-dots-2023-11-27-05-16-50-utc_1_yrjuyj.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/tired-seaman-ab-or-bosun-on-deck-of-vessel-or-ship-2023-11-27-05-27-53-utc_1_qyq2cr.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/lng-liquified-natural-gas-tanker-anchored-in-gas-2024-12-08-00-49-24-utc_1_ky72mh.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/aerial-view-oil-terminal-industrial-facility-stora-2025-01-08-10-36-10-utc_1_cmo2a6.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775080/paper-boats-on-light-blue-surface-on-white-backgro-2024-11-17-06-54-26-utc_1_rkkbzq.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/oil-refinery-plant-at-sunset-gas-chemical-equipme-2024-12-08-01-01-18-utc_1_znezyy.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736805619/above-the-clouds-2023-11-27-05-10-57-utc_1_r1r1eb.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736805622/vessel-crew-preparing-vessel-for-static-tow-tanker-2023-11-27-04-53-51-utc_1_k8gipf.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736805618/aerial-view-of-oil-tankers-in-port-2025-01-09-12-25-41-utc_1_k67hxr.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736805618/oil-refinery-plant-at-sunset-gas-chemical-equipme-2024-12-08-01-01-18-utc_2_rjiyjt.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736810961/yacht-and-airplane-creative-design-on-smartphone-2024-12-29-20-07-12-utc_1_kg5um1.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736810961/old-rusty-ship-is-parked-in-the-port-during-a-vibr-2023-11-27-04-59-51-utc_1_fm0zpf.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736810964/many-oil-crude-gas-tanker-ship-cargo-container-sh-2024-12-08-00-50-51-utc_1_udjbcs.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736810961/a-person-holding-up-a-transparent-globe-with-dots-2023-11-27-05-16-50-utc_2_q8unyq.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1736810960/lpg-ship-oil-tanker-ship-red-oil-tanker-ranchore-2024-12-08-00-43-10-utc_1_t8jrka.png",
        "https://res.cloudinary.com/dot2onqdb/image/upload/v1732090405/Heavy_Lift_Pipe-lay_Multi_Purpose_Vessel.I15.2k_1_tmbjfy.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1739805783/image_31_wzx45h.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471102/psv_eny33s.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471102/ahts_pfl7kj.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/fsiv_kj79ls.png",
        "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png",
      ];

      const images = imageUrls.map((src) => {
        const img = new Image();
        img.src = src;
        return img;
      });

      Promise.all(
        images.map(
          (img) =>
            new Promise((resolve) => {
              img.onload = resolve;
            })
        )
      ).then(() => {
        setImageLoaded(true);
        sessionStorage.setItem("bgImageLoaded", "true");
      });
    }
  }, [imageLoaded]);


  const [scrollProgress, setScrollProgress] = useState(0);
  const [clonedItems, setClonedItems] = useState([]);
  const [hasCounted, setHasCounted] = useState(false);

  useEffect(() => {
    setClonedItems([...items, ...items]);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const itemListRef = useRef(null);

  const scrollToNextItem = () => {
    if (!itemListRef.current) return;

    const maxScrollAmount = 300; // Scroll by 300px
    const { scrollLeft, scrollWidth, clientWidth } = itemListRef.current;

    // Scroll normally
    itemListRef.current.scrollBy({
      left: maxScrollAmount,
      behavior: "smooth",
    });

    // If near the end of the cloned list, reset without visible jump
    if (scrollLeft + clientWidth >= scrollWidth - maxScrollAmount) {
      setTimeout(() => {
        itemListRef.current.scrollTo({ left: 0, behavior: "auto" });
      }, 500); // Small delay to allow smooth transition
    }
  };

  const scrollToPrevItem = () => {
    if (itemListRef.current) {
      const maxScrollAmount = 300; // Limit to 300px
      const { scrollLeft } = itemListRef.current;

      // Scroll the smaller of maxScrollAmount or the remaining distance to the start
      const scrollAmount = Math.min(maxScrollAmount, scrollLeft);

      if (scrollAmount > 0) {
        itemListRef.current.scrollBy({
          left: -scrollAmount,
          behavior: "smooth",
        });
      }
    }
  };

  // Auto-scroll every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      scrollToNextItem();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (itemListRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = itemListRef.current;
        const totalScrollableWidth = scrollWidth - clientWidth;
        const progress = (scrollLeft / totalScrollableWidth) * 100;
        setScrollProgress(progress);
      }
    };

    const scrollableElement = itemListRef.current;
    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleScroll);
      handleScroll(); // Initial calculation

      return () =>
        scrollableElement.removeEventListener("scroll", handleScroll);
    }
  }, []);

  const currentDate = new Date();
  const dayWithZero = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${dayWithZero} ${currentDate.toLocaleDateString(
    "en-NG",
    { month: "long" }
  )} ${currentDate.getFullYear()}`;

  return (
    <Fragment>
      {!imageLoaded && (
        <div className="full-loader">
          <div className="custom-loader"></div>
        </div>
      )}
      {imageLoaded && (
        <div className="vessel-mother">
          <div className={`vessel-home ${imageLoaded ? "loaded" : "loading"}`}>
            <div className="vessel-overlay">
              <Nice />
              <div className="con-1">
                <h3 data-aos="zoom-in">
                  Seamlessly Connecting <span>Maritime</span> Trade
                </h3>
                <p>
                  Your on-demand solution to connect charterers and shipowners,
                  efficiently and instantly
                </p>
                <div className="links">
                  <Link to="/our_vessels">
                    Find a Vessel <WhiteArror />
                  </Link>
                  <Link to="/jobs">
                    Jobs <RedArrrow />
                  </Link>
                </div>
              </div>
              <div className="con-2">
                <div className="story-1">
                  <div className="image"></div>
                  <span>
                    <div>
                      <h3>TRENDING STORIES</h3>
                      <BsArrowRight className="icon" />
                    </div>
                    <p>U.S. Coast Guard Takes Over Cleanup of $3M Yacht</p>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="banner">
            <div className="box">
              <NiceLog />
              <div className="inner">
                <div className="wrap">
                  <div className="box">
                    <p>RECENTLY LISTED</p>
                    <VisibilitySensor
                      partialVisibility
                      offset={{ bottom: 200 }}
                      delayedCall
                      onChange={(isVisible) => {
                        if (isVisible && !hasCounted) {
                          setHasCounted(true);
                        }
                      }}
                    >
                      {({ isVisible }) => (
                        <h3>
                          {hasCounted ? (
                            <CountUp end={30} duration={10} />
                          ) : (
                            "30"
                          )}
                          +
                        </h3>
                      )}
                    </VisibilitySensor>
                  </div>
                  <div className="line"></div>
                  <div className="box">
                    <p>AVERAGE PRICE</p>
                    <h3>$5k</h3>
                  </div>
                </div>
                {/* <p>Last updated: 04 January 2025</p> */}
                <p>Last updated: {formattedDate}</p>
                <Link to="/our_vessels">
                  Find a Vessel <BsArrowRight />
                </Link>
              </div>
            </div>
            <div className="recently-added">
              <div
                className="item-list"
                ref={itemListRef}
                style={{
                  display: "flex",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {clonedItems.map((item, index) => (
                  <div
                    key={index}
                    className="item-card"
                    style={{ flexShrink: 0, width: "300px" }}
                  >
                    <img src={item.image} alt={item.title} />
                    <p>{item.title}</p>
                  </div>
                ))}
              </div>
              <div className="nav">
                <div className="scroll">
                  <div className="scroll-progress">
                    <div
                      className="progress-bar"
                      style={{ width: `${scrollProgress}%` }}
                    ></div>
                  </div>
                </div>
                <div className="in">
                  <Less onClick={scrollToPrevItem} className="icon-1" />
                  <Greter onClick={scrollToNextItem} className="icon-2" />
                </div>
              </div>
            </div>
          </div>

          <div className="refactor">
            <div className="wrapper">
              <div className="prob">
                <div className="box-1">
                  <p>Problem statement</p>
                  <p>
                    Problem <br /> statement
                  </p>
                  <div className="card">
                    <h3>Simplifying Maritime Operations</h3>
                    <Link to="/our_vessels">
                      Find a Vessel <BsArrowRight />
                    </Link>
                  </div>
                </div>
                <div className="box">
                  <p>
                    Our platform connects charterers and shipowners,
                    streamlining vessel chartering, crewing, logistics, and
                    acquisition. We facilitate faster, easier, and more
                    transparent transactions by automating documentation,
                    brokerage, staffing, and sales.
                  </p>
                  <p>
                    Addressing tight schedules, evolving regulations, and the
                    need for reliable collaborations, we ensure efficiency at
                    every step.
                  </p>
                  <Link>
                    Learn More <BsArrowRight />
                  </Link>
                </div>
              </div>
              <div className="box-2">
                <div className="img"></div>
                <ShipLog />
              </div>
              <div className="inspect">
                <div className="card">
                  <div className="in">
                    <p>vessel inspection</p>
                    <IoMdArrowRoundForward />
                  </div>
                  <div className="over">
                    <Aicon />
                  </div>
                </div>
                <div className="card">
                  <div className="in">
                    <p>Hire a vessel</p>
                    <IoMdArrowRoundForward />
                  </div>
                  <div className="over">
                    <Aicon />
                  </div>
                </div>
                <div className="card">
                  <div className="in">
                    <p>Buy a vessel</p>
                    <IoMdArrowRoundForward />
                  </div>
                  <div className="over">
                    <Aicon />
                  </div>
                </div>
                <div className="card">
                  <div className="in">
                    <p>Security Service</p>
                    <IoMdArrowRoundForward />
                  </div>
                  <div className="over">
                    <Aicon />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="service">
            <div className="wrapper">
              <div className="box-1">
                <p>OUR UNIQUE SOLUTION</p>
                <div className="card">
                  <h3>The All-in-One Digital Maritime Platform</h3>
                </div>
              </div>
              <div className="box-2">
                <p>
                  Solve maritime challenges. Our all-in-one platform simplifies
                  chartering, crewing, compliance, and payments for both vessel
                  owners and charterers.
                </p>
                <Link to="/stake_holder">
                  Learn More <RedArrrow />
                </Link>
              </div>
            </div>
          </div>

          <div className="who-we-are">
            <div className="wrapper">
              <div className="pic">
                <div className="over">
                  <div className="content">
                    <PLay />
                    <p>
                      Since our inception in 2020, we have been dedicated to
                      pioneering groundbreaking technology solutions for the
                      future of transport
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="service">
            <div className="wrapper">
              <div className="box-1">
                <p>STAKEHOLDERS ENGAGEMENT</p>
                <div className="card">
                  <h3>Lead the Way in Maritime Innovation.</h3>
                </div>
              </div>
              <div className="box-2">
                <p>
                  The maritime industry is at a crossroads. Technological
                  advancements, evolving regulations, and the pressing need for
                  sustainability demand a new approach. Join us in shaping the
                  future of maritime. Together, we can unlock new efficiencies,
                  drive innovation, and build a more sustainable and connected
                  maritime industry.
                </p>
                <Link to="/stake_holder">
                  Learn More <RedArrrow />
                </Link>
              </div>
            </div>
          </div>

          <div className="tech">
            <div className="wrapper">
              <div className="pic"></div>
              <Nice />
            </div>
          </div>

          <div className="Faq-container">
            <div className="wrapper">
              <h3>Frequently Asked Questions</h3>
              <div className="questions">
                <ul>
                  {faqs.map((faq, index) => (
                    <li
                      key={index}
                      className={activeIndex === index ? "open" : ""}
                    >
                      <span onClick={() => handleToggleAnswer(index)}>
                        <p>{faq.question}</p>
                        <span className="icons">
                          {activeIndex === index ? (
                            <FiMinus />
                          ) : (
                            <AiOutlinePlus />
                          )}
                        </span>
                      </span>
                      <div className="faq-answer">
                        <p>{faq.answer}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <Link to="/faqs">
                Read More <WhiteArror />
              </Link>
            </div>
          </div>

          <div className="what">
            <div className="wrapper">
              <h3>Latest news and features</h3>
              <div className="card-container">
                {contents.map((item, index) => (
                  <div
                    key={item.id}
                    className={`item-card ${
                      index === 1 ? "highlight-card" : ""
                    }`}
                  >
                    <div className="meta">
                      <p>{item.date}</p>
                      <p>{item.min}</p>
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.content}</p>
                    <img src={item.img} alt="" />
                  </div>
                ))}
              </div>

              <Link to="/news">
                Read More <WhiteArror />
              </Link>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Home;
